import clsx from 'clsx'
import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styles from './LegacyTag.module.scss'

const propTypes = {
  /**
   * Class to override default styles
   */
  className: PropTypes.string,
  /**
   * Size of the tag
   */
  size: PropTypes.oneOf(['md', 'sm']),
}

function LegacyTag(props) {
  const { className = '', size = 'md' } = props ?? {}

  return (
    <span className={clsx(styles.legacy, size === 'sm' && styles.sm, className)}>
      <FormattedMessage id="GENERAL.LEGACY" />
    </span>
  )
}

LegacyTag.propTypes = propTypes

export default LegacyTag
